import React, { useContext } from "react";
import { AuthContext } from '../../../../../auth-context'
import styled from "styled-components";
import Icon from '@material-ui/core/Icon'
import Popover from "@material-ui/core/Popover";
import Checkbox from "@material-ui/core/Checkbox";
import { withStyles } from "@material-ui/core/styles";
import { updatePortalUser } from '../../../../../api'

const WhiteCheckbox = withStyles({
  root: {
    color: "#FFF",
    "&$checked": {
      color: "#FFF",
    },
  },
  checked: {},
})((props) => <Checkbox {...props} />);

const CustomPopover = withStyles({
  paper: {
    background: "#060c29",
    borderRadius: "12px",
  },
})(Popover);

const TableSetting = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-family: "DM Sans", sans-serif;
  font-size: 1rem;
  font-weight: 500;
  span {
    font-size: 1.5rem;
    margin-left: 6px;
  }
`;

const Item = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  p {
    color: #fff;
    white-space: nowrap;
    padding: 0px 18px 0px 0px;
  }
`;

const Content = styled.div`
  color: #fff;
  padding: 6px;
`;

const Description = styled.p`
  margin-left: 42px;
  margin-top: -8px;
  font-size: 0.8rem;
  color: #b9b9b9;
`

const ListItem = ({ name, checked, onChange }) => {
  return (
    <Item>
      <WhiteCheckbox
        checked={Boolean(checked)}
        onChange={onChange}
        inputProps={{ "aria-label": "checkbox" }}
      />
      <p>{name}</p>
    </Item>
  );
};

export function getAttentionSettings(attention_settings) {
  const defaultAttentionSettings = {
    tracking: 1,
    warning: 1,
    late: 1,
    inactive: 1,
    pending: 1,
    checkin: 0,
    email: 0,
    missedtracking: 1
  }
  let result
  if (attention_settings) {
    result = Object.assign({}, defaultAttentionSettings, attention_settings)
  } else {
    result = Object.assign({}, defaultAttentionSettings)
  }
  return result
}

export const AlertSettings = ({accountID, assignedTrainers, index }) => {
  const { user, updateUser } = useContext(AuthContext);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const attentionSettings = getAttentionSettings(user.attention_settings)

  const handleChange = (setting) => {
    let newSettings = {...attentionSettings}

    if (!newSettings.hasOwnProperty(setting)) {
      newSettings[setting] = 1
    } else {
      newSettings[setting] = 1 - newSettings[setting]
    }

    let newUser = Object.assign({}, user)
    newUser['attention_settings'] = newSettings
    updateUser(newUser)
  }

  const saveSettings = () => {
    updatePortalUser(user.id, { 
      attention_settings: JSON.stringify({...attentionSettings}),
    }
    ).then((res) => {
      // openSnackbar('Parameters saved.', false)
    }).catch((err) => {
      console.log(err)
      // openSnackbar('There was a problem updating your account info.', true)
    });
  }

  return (
    <>
      <TableSetting onClick={(e) => setAnchorEl(e.currentTarget)}>
        Set Parameters <Icon>settings</Icon>
      </TableSetting>
      <CustomPopover
        id={accountID}
        open={open}
        anchorEl={anchorEl}
        onClose={() => { setAnchorEl(""); saveSettings(); }}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <Content>
          <ListItem
            name="Incomplete tracking"
            checked={attentionSettings.tracking}
            onChange={() => handleChange('tracking')}
          />
          <ListItem
            name="Check-in warrants examination"
            checked={attentionSettings.warning}
            onChange={() => handleChange('warning')}
          />
          <ListItem
            name="Late for check-in"
            checked={attentionSettings.late}
            onChange={() => handleChange('late')}
          />
          <ListItem
            name="Not using system"
            checked={attentionSettings.inactive}
            onChange={() => handleChange('inactive')}
          />
          <Description>
            Client has not tracked in 14 days
          </Description>
          <ListItem
            name="Pending new user"
            checked={attentionSettings.pending}
            onChange={() => handleChange('pending')}
          />
          <ListItem
            name="Checked-in today"
            checked={attentionSettings.checkin}
            onChange={() => handleChange('checkin')}
          />
          <Description>
            Client checked in earlier today
          </Description>
        </Content>
      </CustomPopover>
    </>
  );
};
